import Aos from "aos";
import React, { useState, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import "../Css/BioTable.css";
import { LINK_DATAS_ROOT } from "../utils/datas";
import { currentLang } from "../utils/lang";
function FileReader_tr({ item }) {
  const [detail, setDetail] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {    
    Aos.init();
    Aos.refresh();
  }, []);

  return (
    <div className="bio-tr-container">
      <tr
        className={
          "ui bio-table-tr " + (item[4] ? "bio-table-tr-hoverable" : "")
        }
        //data-aos="fade-right"
        onClick={(e) => {
          console.log("click");
          setIsOpen(!isOpen);
        }}
      >
        <td>{item[0]}</td>

        <td className="bio-icon">
          <Icon name={item[2]}></Icon>
          {item[1]}
        </td>
        <td className="bio-content">{item[3]}</td>
      </tr>
      {item[4] && (
        <iframe
          id="bio-tr-iframe"
          src={LINK_DATAS_ROOT + currentLang + "/" + item[4] + ".html"}
          className={isOpen ? "bio-detail-open" : "bio-detail-close"}
        ></iframe>
      )}
    </div>
  );
}

export default FileReader_tr;
